import { useCallback, useMemo } from 'react';
import { Flex } from 'antd';
import MenuSVG from '../../icons/MenuSVG';
import { useTranslation } from 'react-i18next';
import langIconEn from '../../assets/lang-1.png';
import langIconHy from '../../assets/lang-2.png';
import langIconRu from '../../assets/lang-3.png';
import MyLink from '../../components/myLink/MyLink';
import { useLocation, useNavigate } from 'react-router-dom';
import MyDropDown from '../../components/myDropDown/MyDropDown';

const flagMap = {
  en: langIconEn,
  hy: langIconHy,
  ru: langIconRu,
};

const OutsideLayoutHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();

  const currentLang = i18n.language?.slice(0, 2) || 'en';

  const handleLanguageChange = useCallback(
    (lang) => {
      i18n.changeLanguage(lang);
      const newPath = `/${lang}${location.pathname.slice(3)}`;
      navigate(newPath);
    },
    [i18n, location.pathname, navigate]
  );

  const items = useMemo(() => {
    return [
      {
        key: 'en',
        label: t('WORD_ENGLISH'),
        onClick: () => handleLanguageChange('en'),
      },
      {
        key: 'hy',
        label: t('WORD_ARMENIAN'),
        onClick: () => handleLanguageChange('hy'),
      },
      {
        key: 'ru',
        label: t('WORD_RUSSIAN'),
        onClick: () => handleLanguageChange('ru'),
      },
      // {
      //   key: 'ar',
      //   label: t('WORD_ARABIC'),
      //   onClick: () => handleLanguageChange('ar'),
      // },
    ];
  }, [handleLanguageChange, t]);

  const imgSize = 44;

  return (
    <Flex justify="space-between">
      <MyLink path="/login">
        <MenuSVG />
      </MyLink>
      <MyDropDown arrow="false" items={items} placement="bottomRight">
        <img
          style={{
            width: imgSize,
            height: imgSize,
            borderRadius: '50%',
            objectFit: 'cover',
            display: 'block',
          }}
          src={flagMap[currentLang] || langIconEn}
          alt="flag"
        />
      </MyDropDown>
    </Flex>
  );
};

export default OutsideLayoutHeader;
